import {Helmet} from "react-helmet-async";
import {isMobile, LINKS} from "../App";
import {TopParallax} from "../components/TopParallax";
import Gap from "../components/Gap";
import getText from "../locale/lang";
import Counter from "../components/Counter";
import {Box, Container} from "@mantine/core";
import Remastered from "../components/Features/Remastered";
import {useContext} from "react";
import {SiteDataContext} from "../components/SiteDataProvider";
import useSiteData from "../hooks/useSiteData";

export default function Features() {
    const {server} = useContext(SiteDataContext);
    const {siteData} = useSiteData(server, localStorage.getItem('lang'), true);

    return <>
        <Helmet>
            <title>Dares - {getText('features')} L2 Server</title>
            <link rel="canonical" href={`${LINKS.mainUrl}/`}/>
        </Helmet>

        <TopParallax image={siteData && siteData.img && `${LINKS.filesUrl}/${siteData.img}`}>
            <Box className="container" style={{
                display: "flex",
                height: '100%',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'space-between'
            }}>
                <Box style={{width: '50%'}}>
                    {isMobile ? <h3>{siteData !== undefined && siteData?.title}</h3> :
                        <h2 style={{color: '#e08821'}}>{siteData?.title}</h2>}
                    <h1 style={{fontSize: 56}}>{siteData?.description}</h1>
                </Box>
                <Box style={{display: "flex", justifyContent: 'center', flexDirection: 'column', width: '50%'}}>
                    {siteData && siteData.counters.map((counter, i) =>
                        <Counter key={i} title={counter.title} date={new Date(counter.date)} color={'white'}/>)}
                </Box>
            </Box>
        </TopParallax>
        <Gap/>
        <Container>
            <Remastered/>
            {isMobile && <><Gap/><Gap/></>}
        </Container>
    </>
}